import axiosClient from './axiosClient';

const orderService = {
    recentOrders: async () => {
        const response = await axiosClient.get('/vendor/orders/recent/all');
        return response.data;
    },
    allOrders: async (filterParams) => {
        const response = await axiosClient.get('/vendor/orders', filterParams ? { params: filterParams } : {});
        return response.data;
    },
    adminAllOrders: async (filterParams) => {
        const response = await axiosClient.get('/admin/orders', filterParams ? { params: filterParams } : {});
        return response.data;
    },
    adminGetOrderDetails: async (orderId) => {
        const response = await axiosClient.get(`/admin/orders/${orderId}`);
        return response.data;
    },
    adminUpdateOrderStatus: async (orderId, data) => {
        const response = await axiosClient.put(`/admin/orders/${orderId}/status`, data);
        return response.data;
    },
    adminAssignRider: async (orderId, riderId) => {
        const response = await axiosClient.put(`/admin/orders/${orderId}/assign-rider`, { riderId });
        return response.data;
    },
    vendorAssignRider: async (orderId, riderId) => {
        const response = await axiosClient.put(`/vendor/orders/${orderId}/assign-rider`, { riderId });
        return response.data;
    },
    vendorNotifyRider: async (orderId) => {
        const response = await axiosClient.put(`/vendor/orders/${orderId}/notify-rider`);
        return response.data;
    },
    getAvailableRiders: async (orderId) => {
        const response = await axiosClient.get(`/vendor/orders/${orderId}/available-riders`);
        return response.data;
    },
    updateOrderStatus: async (orderId, data) => {
        const response = await axiosClient.put(`/vendor/orders/${orderId}/status`, data);
        return response.data;
    },
    getOrderDetails: async (orderId) => {
        const response = await axiosClient.get(`/vendor/orders/${orderId}`);
        console.log(response.data);
        return response.data;
    },
    adminGetRiderLocation: async (orderId) => {
        const response = await axiosClient.get(`/admin/orders/${orderId}/rider-location`);
        return response.data;
    },
    vendorGetRiderLocation: async (orderId) => {
        const response = await axiosClient.get(`/vendor/orders/${orderId}/rider-location`);
        return response.data;
    }
};

export default orderService;
